import React, { useContext, useRef, useState } from 'react';


import background2 from '../sections/images/Background2.png'
import background3 from '../sections/images/Background4.png'

import hero from "../sections/images/hero.png"
import { StyleClass } from 'primereact/styleclass';
import { Button } from 'primereact/button';
import { Ripple } from 'primereact/ripple';
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import { Hero } from '../sections/hero';
import { Unified_Platform } from '../sections/unified-platform';
import { Security_Privacy } from '../sections/security-privacy';
import { Why_Clincove } from '../sections/why-clincove';
import { HeroNoText } from '../sections/hero-no-text';
import { Guides } from '../sections/guides';
import { WhitePaper } from '../sections/white-paper';
import { Blog } from '../sections/blog';
import { OurMission } from '../sections/our-mission';
import { About_Us } from '../sections/about-us';



export const AboutUs = () => {

    return (<>

        <Hero />
        <div style={{ backgroundColor: "#6200EE", border: "0px" }}>
            <OurMission />
        </div>
        <div style={{ border: "black 0px solid" }}>
            <About_Us />
        </div>









    </>)

}
